
















import {Component, Vue} from "vue-property-decorator";

@Component({
  name: "testing-step-5",
})
export default class TestingStep5 extends Vue{
  mounted () {
    this.$emit('next-step-available');
  }
}
